
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b0092384!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppHeader.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppHeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b0092384!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppHeader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/AppHeader.vue
// module id = ./dev/src/components/AppHeader.vue
// module chunks = 0